import React from "react";
import Layout from "../Layout/Layout";
import IntrestVendor from "../../components/InterestVendor/IntrestVendor";

function ManageInventoryFlow() {
  return (
      <Layout child="Interested Vendor">
          <IntrestVendor/>
    </Layout>
  );
}

export default ManageInventoryFlow;
